import React from "react";
import Loadable from "../../react-loadable";
import middleware from "../../middleware";

const Draggable = Loadable({
  loader: () => import("react-draggable"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
class Main extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Draggable {...this.props} ecId={`${this.props.ecId}_Draggable@e2wlgv`} />
    );
  }
}

const Com = middleware(Main, "WeaDraggable");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-draggable/index.js